import React, { useState } from "react";
import { BsFillCloudSunFill } from "react-icons/bs";
//API Key from openweathermap.org
const api = {
	key: `${process.env.REACT_APP_WEATHER_API_KEY}`,
	base: "https://api.openweathermap.org/data/2.5/",
};

function App() {
	const [query, setQuery] = useState("");
	const [weather, setWeather] = useState({});

	// evt = event
	const search = (evt) => {
		if (evt.key === "Enter") {
			fetch(`${api.base}weather?q=${query}&units=metric&APPID=${api.key}`) //get info from API
				.then((res) => res.json()) //Get response and turn response into json
				.then((result) => {
					setQuery("");
					setWeather(result); //response is return in the result, we setWeather to the result to update the weather
					console.log(result);
				});
		}
	};

	const dateBuilder = (d) => {
		let months = [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December",
		];
		let days = [
			"Monday",
			"Tuesday",
			"Wednesday",
			"Thursday",
			"Friday",
			"Saturday",
			"Sunday",
		];

		let day = days[d.getDay()]; //return a number between 0 and 6
		let date = d.getDate();
		let month = months[d.getMonth()]; //return a number between 0 and 11
		let year = d.getFullYear();

		return `${day} ${date} ${month} ${year}`; //display the date
	};

	return (
		// *** ADD bg for Mist ***
		<div
			className={
				typeof weather.main != "undefined"
					? (weather.main.temp > 16 && weather.weather[0].main === "Clear"
							? "warm"
							: null) ||
					  (weather.main.temp < 16 && weather.weather[0].main === "Clear"
							? "coldClear"
							: null) ||
					  (weather.main.temp > 16 && weather.weather[0].main === "Clouds"
							? "clouds"
							: null) ||
					  (weather.main.temp < 16 && weather.weather[0].main === "Clouds"
							? "coldClouds"
							: null) ||
					  (weather.weather[0].main === "Rain" ? "rain" : null)
					: "app"
			}
		>
			<main>
				<div className="search-box">
					<input
						type="text"
						className="search-bar"
						placeholder="Search..."
						onChange={(e) => setQuery(e.target.value)}
						value={query}
						onKeyPress={search}
					/>
				</div>
				{/* //Display weather info if search bar is not empty and API request has
				gone through */}
				{typeof weather.main != "undefined" ? (
					<div>
						<div>
							<div className="location-box">
								<div className="location">
									{weather.name}, {weather.sys.country}
								</div>
								<div className="date">{dateBuilder(new Date())}</div>
							</div>
						</div>
						<div className="weather-box">
							<div className="temp">{Math.round(weather.main.temp)}°C</div>
							<div className="weather">{weather.weather[0].main}</div>
						</div>
						<div className="info-container">
							<div className="info-box">
								<table className="info-table">
									<tbody>
										<tr className="info-row">
											<td>feels like</td>
											<td>{Math.round(weather.main.feels_like)}°C</td>
										</tr>
										<tr className="info-row">
											<td>high</td>
											<td>{Math.round(weather.main.temp_max)}°C</td>
										</tr>
										<tr className="info-row">
											<td>low</td>
											<td>{Math.round(weather.main.temp_min)}°C</td>
										</tr>
										<tr className="info-row">
											<td>humidity</td>
											<td>{Math.round(weather.main.humidity)}%</td>
										</tr>
										<tr className="info-row">
											<td>pressure</td>
											<td>{Math.round(weather.main.pressure)} hPa</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				) : (
					<div>
						<div className="home-box">
							<span className="icon">
								<BsFillCloudSunFill />
							</span>
							<span className="titleUpper">
								<h1>INSTANT</h1>
							</span>
							<span className="titleUnder">
								<h2>WEATHER</h2>
							</span>
							<div className="home">press Enter</div>
						</div>
					</div>
				)}
			</main>
		</div>
	);
}

export default App;
